import React, { useMemo } from 'react';
import { TypedMemo } from '../../../../common/types';
import { ErrorView } from '../../../../common/views/ErrorView/ErrorView';
import { LoadingView } from '../../../../common/views/LoadingView';
import { ReleaseTabProps } from '../releaseTabProps';
import { ReelsPlanPanel } from '../plan/reelsPlan/ReelsPlanPanel';
import { useReleasePlanChannels } from '../plan/useReleasePlanChannels';
import { campaignPlanChannels } from '../plan/reelsPlan/reelsPlanChannels';

/**
 * The Auto campaign tab of a release (`?tab=campaign`; owner decision 2026-10-12): the AI reels
 * campaign of the song is the whole content of the tab (design rollout-plan f1-f6,
 * `plan/reelsPlan/ReelsPlanPanel`). The panel waits for the usable channels of the artist, so the
 * tab shows the load and the error of the channels.
 */
const CampaignTabComponent: React.FC<ReleaseTabProps> = ({ accountId, item, release }) => {
  const { channels: rows, platforms, isLoading, error, retry } = useReleasePlanChannels(accountId);
  // A placeholder channel with no handle gets no post (QA finding B14). The rows are memoised by
  // the hook, so the campaign channels change only when the rows change.
  const channels = useMemo(
    () => campaignPlanChannels({ channels: rows, platforms, isLoading, error, retry }),
    [error, isLoading, platforms, retry, rows]
  );
  if (channels.isLoading) {
    return <LoadingView />;
  }
  if (channels.error !== undefined) {
    return <ErrorView error={channels.error} retry={channels.retry} />;
  }
  return <ReelsPlanPanel accountId={accountId} item={item} release={release} channels={channels} />;
};

export const CampaignTab = TypedMemo(CampaignTabComponent);
